import React from 'react'
import Layout from '../../Components/Layout'
import BannerGlobal from '../../Components/BannerGlobal'
import PricingTable2 from '../../Components/PricingTable2'
import useDocumentTitle from '../../Hooks/PageTitle'

const PricingPage = () => {
  useDocumentTitle("TRoo SEO Agency | Pricing Cards")
  return (
    <Layout>
    <BannerGlobal/>
    <PricingTable2/>
  </Layout>
  )
}

export default PricingPage